import HeadTittle from '../../../../../components/HeadTittle';
import DivContainerBody from '../../../../../components/DivContainerBody';
import { RequestDetailsApp } from '../Functionality/RequestDetailsApp';
import {status, STATUS_MODEL} from '../../../../../enums/statusEnum';
import LevelDocumentCard from './LevelDocumentCard';
import CustomUserChip from '../../../../../components/CustomUserChip';
import { POSITION_MODEL } from '../../../../../Helpers/PositionModel';
import { PROFILE_MODEL } from '../../../../DocumentationApprovalFlow/Model/Model';
import React from 'react';
import CancelModal from '../../../Dining/Schedules/Modal/CancelModal';
import {getInfoParagraphByStatus} from '../../../ApprovalTracker/Model/Model';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const RequestDetails = ({userTypeId}) => {
    const {
        t,
        genericCommentModals,
        documentationApproval,
        setShowApprove,
        setShowDenied,
        setShowIssueComment,
        setRow,
        statusData,
        handleOnBack,
        chipClass,
        iconClass,
        profile,
        handleOnClick
    } = RequestDetailsApp({
        userTypeId
    });

    return (
        <>
            <HeadTittle
                name={profile === PROFILE_MODEL.VEHICLE ?
                    (`${documentationApproval?.brand} ${documentationApproval?.subBrand} - ${documentationApproval?.plates} `) :
                    documentationApproval.fullName}
                onBack={handleOnBack}
            />
            <DivContainerBody>
                <div className={'border-radius-8px border-full-shades-300 p-16px'}>
                    <div className={'d-flex justify-content-between align-items-center mb-24px'}>
                        <p className='font-color-primary-800 ibl-font-w-600 fs-24px'>{t('documentation_status')}</p>
                        <CustomUserChip
                            name={t(status[documentationApproval?.approvalStatusId])}
                            Icon={statusData?.Icon}
                            showAvatar={true}
                            className={chipClass}
                            variant='large'
                            iconPosition={POSITION_MODEL.LEFT}
                            classNameIcon={iconClass}
                        />
                    </div>

                    {(profile === PROFILE_MODEL.VEHICLE
                        ? documentationApproval?.vehicles
                        : documentationApproval?.users
                    )?.map((item, index) => {
                        let disabled = true;
                        if (index === 0) {
                            disabled = false;
                        } else {
                            const aux = profile === PROFILE_MODEL.VEHICLE
                                ? documentationApproval?.vehicles
                                : documentationApproval?.users;
                            const prevLevel = aux[index - 1];
                            if (prevLevel?.statusId === STATUS_MODEL.APPROVED) {
                                disabled = false;
                            }
                        }
                        return (
                            <LevelDocumentCard
                                item={item}
                                t={t}
                                disabled={disabled}
                                setRow={setRow}
                                setShowApprove={setShowApprove}
                                setShowDenied={setShowDenied}
                                setShowIssueComment={setShowIssueComment}
                            />
                        );
                    })}
                </div>

                {genericCommentModals.map(({
                    show,
                    setter,
                    title,
                    status,
                    requiredComment,
                    onClick
                }) => {
                    return (
                        <>
                            <CancelModal
                                show={show}
                                onHide={() => setter(false)}
                                onConfirm={(e, comment) => {
                                    handleOnClick(onClick, comment, status);
                                }}
                                requiredComment={requiredComment}

                                title_modal={title}
                                description={t("are_you_sure_to_proceed")}
                                subDescription={t(getInfoParagraphByStatus(status))}
                            />
                        </>
                    );
                })}
            </DivContainerBody>
        </>
    );
};

export default RequestDetails;
